export default "__VITE_ASSET__CT1sGd6o__"